import React, { useState } from 'react';
import { DashboardHeader } from './components/DashboardHeader';
import { KPISummary } from './components/KPISummary';
import { PipelineStagnation } from './components/PipelineStagnation';
import { SubmissionQuality } from './components/SubmissionQuality';
import { PullThroughMetrics } from './components/PullThroughMetrics';
export const ALL_LOAN_OFFICERS = ['Sarah Chen', 'Michael Davis', 'Chrao Dunon', 'Alex Kim', 'Priya Patel', 'Jann Fmt', 'Roda Kim'];
export function App() {
  const [selectedTeam, setSelectedTeam] = useState('all');
  const [dateRange, setDateRange] = useState('last-30-days');
  const [selectedLO, setSelectedLO] = useState('all');
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <DashboardHeader selectedTeam={selectedTeam} setSelectedTeam={setSelectedTeam} dateRange={dateRange} setDateRange={setDateRange} selectedLO={selectedLO} setSelectedLO={setSelectedLO} data-id="element-1" />

      <main className="max-w-[1600px] mx-auto px-6 py-8 space-y-8" data-id="element-2">
        <KPISummary selectedLO={selectedLO} data-id="element-3" />

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6" data-id="element-4">
          <PipelineStagnation selectedLO={selectedLO} data-id="element-5" />
          <SubmissionQuality selectedLO={selectedLO} data-id="element-6" />
        </div>

        <PullThroughMetrics selectedLO={selectedLO} data-id="element-7" />
      </main>
    </div>;
}